/**
 * Get previous HTML element which is visible.
 *
 * @see https://stackoverflow.com/a/31207879/5506547
 * @see https://stackoverflow.com/a/21696585/5506547
 */
function getPreviousVisibleElement(node) {
  function prevAll(element) {
    var result = [];

    while (element = element.previousElementSibling) {
      result.push(element);
    }

    return result;
  }

  var previousVisible = prevAll(node).filter(function (e) {
    return e.offsetParent;
  });
  return previousVisible.length ? previousVisible[0] : undefined;
}

export { getPreviousVisibleElement };